import React, { useCallback, useState } from 'react';
import { Stack, Tab, Tooltip, Typography } from '@mui/material';
import { HeadlessPageWrapper } from 'templates/PageWrapper/PageWrapper';
import { StyledPaper } from 'pages/ContactsPage/Contacts.styles';
import { StyledTabList } from 'molecules/Card/Card.styles';
import { StyledTabPanel } from 'organisms/CompanyInvoicesTabs/CompanyInvoicesTabs.styles';
import { TabContext, TabPanel } from '@mui/lab';
import CloudOpsReport from 'organisms/CloudOpsReport/tabs/CloudOpsReport';
import SecurityReport, {
  spaDescriptionText,
} from 'organisms/CloudOpsReport/tabs/SecurityReport';
import ObservabilityReport, {
  observabilityDescriptionText,
} from 'organisms/CloudOpsReport/tabs/Observability';
import { useBaoSelector } from 'utils/hooks/redux';
import { NewBadge } from 'molecules/NewBadge';
import { HelpOutlineOutlined } from '@mui/icons-material';

type TabType = 'projectInvoicing' | 'securityReports' | 'infraObservability';

const CloudOpsReportPage = () => {
  const { value: user } = useBaoSelector((state) => state.user);

  const [selectedTab, setSelectedTab] = useState<TabType>('projectInvoicing');

  const handleChangeTabs = useCallback(
    (event: React.SyntheticEvent, newValue: TabType) => {
      setSelectedTab(newValue);
    },
    []
  );

  function a11yProps(index: number) {
    return {
      id: `tab-${index}`,
      'aria-controls': `tabpanel-${index}`,
    };
  }

  return (
    <HeadlessPageWrapper>
      <StyledPaper sx={{ minWidth: '1150px !important' }}>
        <TabContext value={selectedTab}>
          <StyledTabList
            onChange={handleChangeTabs}
            aria-label="CloudOps Reports tabs"
            variant="fullWidth"
          >
            <Tab
              label="Project Invoicing"
              {...a11yProps(1)}
              className={selectedTab === 'projectInvoicing' ? '.active' : ''}
              value="projectInvoicing"
            />
            <Tab
              label={
                <NewBadge offsetX={-6}>
                  <Tooltip
                    title={
                      <Stack>
                        <Typography
                          variant="body2"
                          fontSize="12px"
                          sx={{ fontWeight: 'bold', color: '#FFFFFF' }}
                        >
                          See Where Your Business Is at Risk!
                        </Typography>
                        {spaDescriptionText}
                      </Stack>
                    }
                  >
                    <HelpOutlineOutlined
                      sx={{ width: 16, height: 16, mr: 1 }}
                    />
                  </Tooltip>
                  Security Reports
                </NewBadge>
              }
              {...a11yProps(0)}
              className={selectedTab === 'securityReports' ? '.active' : ''}
              value="securityReports"
            />
            <Tab
              label={
                <NewBadge offsetX={-6}>
                  <Tooltip title={observabilityDescriptionText}>
                    <HelpOutlineOutlined
                      sx={{ width: 16, height: 16, mr: 1 }}
                    />
                  </Tooltip>
                  Infrastructure Observability
                </NewBadge>
              }
              {...a11yProps(0)}
              className={selectedTab === 'infraObservability' ? '.active' : ''}
              value="infraObservability"
            />
          </StyledTabList>
          <StyledTabPanel value="projectInvoicing" sx={{ p: 0 }}>
            <CloudOpsReport />
          </StyledTabPanel>
          <TabPanel value="securityReports" sx={{ p: 0 }}>
            <SecurityReport userId={user?.userId} />
          </TabPanel>
          <TabPanel value="infraObservability" sx={{ p: 0 }}>
            <ObservabilityReport userId={user?.userId} />
          </TabPanel>
        </TabContext>
      </StyledPaper>
    </HeadlessPageWrapper>
  );
};

export default CloudOpsReportPage;
